import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from './../data/store'
import { searchIfscThroughBranchIdBody } from './ApiBody/searchIfscThroughBranchIdBody'
import { APIEndPoints } from './APIEndpoints'
import { bankConfig } from './config'

const responseParser = (data: any) => {
  const parsedData = data?.data?.response
  return parsedData
}

const returnHeader = () => {
  return {
    'Content-Type': 'application/json',
    Authorization: RootStore.user.session.userAccessToken ?? '',
  }
}

const searchIfscThroughBranchIdRequest = (passedData: any) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.searchIfscThroughBranchId,
    method: 'POST',
    config: bankConfig(RootStore.user.session.getTokens, true),
    body: searchIfscThroughBranchIdBody(passedData),
    headers: returnHeader(),
  }

  return executeRequest(request).then((data: any) => {
    return responseParser(data)
  })
}

export { searchIfscThroughBranchIdRequest }
